import 'babel-polyfill';
import * as OfflinePluginRuntime from 'offline-plugin/runtime';
import uuid from 'uuid/v1';
import reqwest from 'reqwest';
import settings from './constants/settings';

import renderApp from './renderApp';

OfflinePluginRuntime.install();

if (!localStorage.getItem('uuid')) {
  localStorage.setItem('uuid', uuid());
}

reqwest({
  url: settings.CREATE_UPDATE_USER_URL,
  data: {
    arn: 'web',
    phone: '',
    user_id: localStorage.getItem('userid') || '-1',
    token: localStorage.getItem('uuid'),
  },
  method: 'GET',
  crossOrigin: true,
}).then(data => {
  localStorage.setItem('userid', data.user_id);
});

renderApp();



// WEBPACK FOOTER //
// ./src/js/main.js